import { CloseIcon } from '../../../assets/icons/Svg';

interface ClientUpdatePackageProductsHeaderProps {
    onClose: () => void;
}

export default function ClientUpdatePackageProductsHeader({ onClose }: ClientUpdatePackageProductsHeaderProps) {

    return (
        <div className="flex justify-between items-center py-1">
            <div>
                <p className="text-sm font-semibold leading-tight text-slate-900">
                    Update Products
                </p>
                <p className="text-sm text-slate-500 mt-1">
                    Manage the availability of products and add-ons.
                </p>
            </div>
            <button
                type="button"
                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 inline-flex justify-center items-center"
                onClick={onClose}
            >
                <CloseIcon />
            </button>
        </div>
    )
}
